import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { ICategory } from '@obvious.tech/constellation'

export const Category = defineEntity('Category', {
  endpoint: 'alarms/api/Category',
  schema: SNoop<ICategory>(),
})
